import { render, staticRenderFns } from "./TheRecipientsBulkMethods.vue?vue&type=template&id=473818cf&scoped=true"
import script from "./TheRecipientsBulkMethods.vue?vue&type=script&lang=js"
export * from "./TheRecipientsBulkMethods.vue?vue&type=script&lang=js"
import style0 from "./TheRecipientsBulkMethods.vue?vue&type=style&index=0&id=473818cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473818cf",
  null
  
)

export default component.exports